import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    email: '',
    phone_number: '',
    name: '',
    birthMonth: '',
    birthDay: '',
    platform: '',
    optInMarketing: false,
    errors: {},
    qr: null,
    formQr: null,
    merchantId: null,
    statusMessage: null,
    emailSent: null, // { ok: boolean, reason?: string } from pass creation
};

const generateSlice = createSlice({
    name: 'generate',
    initialState,
    reducers: {
        setEmail: (state, action) => {
            state.email = action.payload;
        },
        setPhoneNumber: (state, action) => {
            state.phone_number = action.payload;
        },
        setName: (state, action) => {
            state.name = action.payload;
        },
        setBirthMonth: (state, action) => {
            state.birthMonth = action.payload;
        },
        setBirthDay: (state, action) => {
            state.birthDay = action.payload;
        },
        setPlatform: (state, action) => {
            state.platform = action.payload;
        },
        setOptInMarketing: (state, action) => {
            state.optInMarketing = action.payload;
        },
        setErrors: (state, action) => {
            state.errors = action.payload;
        },
        setQr: (state, action) => {
            state.qr = action.payload;
        },
        setFormQr: (state, action) => {
            state.formQr = action.payload;
        },
        setMerchantId: (state, action) => {
            state.merchantId = action.payload;
        },
        setStatusMessage: (state, action) => {
            state.statusMessage = action.payload;
        },
        setEmailSent: (state, action) => {
            state.emailSent = action.payload;
        },
        resetGenerate: (state) => {
            const preservedFormQr = state.formQr;
            Object.assign(state, initialState);
            state.formQr = preservedFormQr;
        },
    },
});

export const {
    setEmail,
    setPhoneNumber,
    setName,
    setBirthMonth,
    setBirthDay,
    setPlatform,
    setOptInMarketing,
    setErrors,
    setQr,
    setFormQr,
    setMerchantId,
    setStatusMessage,
    setEmailSent,
    resetGenerate,
} = generateSlice.actions;
export default generateSlice.reducer;
